import { HeroSection } from '../components/HeroSection';
import { ContactForm } from '../components/ContactForm';
import { useSiteContent } from '../hooks/useSiteContent';
import { useLanguage } from '../i18n/LanguageContext';
import { mediaUrl } from '../services/api';

const PAGE_SLUG = 'iletisim';

export function ContactPage() {
  const { getPage, getBlock, content } = useSiteContent();
  const { t } = useLanguage();
  const page = getPage(PAGE_SLUG);
  const intro = getBlock(PAGE_SLUG, 'contact_intro');
  const { settings } = content;
  const heroImage = mediaUrl(page?.heroImage);

  return (
    <>
      {/* HeroSection metinleri kendi icinde cevrilir */}
      <HeroSection
        eyebrow="İletişim"
        title={page?.heroTitle || intro?.title || 'Bizimle <em>İletişime</em> Geçin'}
        subtitle={page?.heroSubtitle || intro?.subtitle}
        imageUrl={heroImage}
      />

      <section>
        <div className="container grid-2">
          <div>
            <div className="eyebrow-sm">{t('İletişim Bilgileri')}</div>
            <h2 className="section-title">
              {t(intro?.title || 'Size Nasıl Yardımcı Olabiliriz?')}
            </h2>
            <p className="section-desc">
              {t(
                intro?.content ||
                  'Sorularınız ve teklif talepleriniz için formu doldurun, ekibimiz en kısa sürede size dönüş yapsın.',
              )}
            </p>
            <div className="stat-row" style={{ margin: 0 }}>
              <div>
                <b style={{ fontSize: 15 }}>{t(settings.footerAddress)}</b>
                <span>{t('Adres')}</span>
              </div>
            </div>
            <div className="stat-row">
              <div>
                <b style={{ fontSize: 18 }}>{settings.footerPhone}</b>
                <span>{t('Telefon')}</span>
              </div>
              <div>
                <b style={{ fontSize: 18 }}>{settings.footerEmail}</b>
                <span>{t('E-posta')}</span>
              </div>
            </div>
          </div>
          <ContactForm />
        </div>
      </section>

      {settings.mapEmbedUrl ? (
        <section style={{ padding: 0 }}>
          <iframe
            title={t('Harita')}
            src={settings.mapEmbedUrl}
            style={{ width: '100%', height: 380, border: 'none', display: 'block' }}
            loading="lazy"
          />
        </section>
      ) : (
        <section className="section-navy">
          <div className="container center">
            <div className="eyebrow-sm center" style={{ color: '#ff8b84' }}>
              {t('Konum')}
            </div>
            <h2 className="section-title" style={{ color: '#fff' }}>
              {t(settings.mapAddress || settings.footerAddress)}
            </h2>
            <p style={{ color: '#c7cdea' }}>
              {t(`36° 50' 22" Kuzey · 35° 53' 53" Doğu`)}
            </p>
          </div>
        </section>
      )}
    </>
  );
}
